export const isNotEmpty = (object)=>{
    return object &&  Object.keys(object).length;
}

export const isEmpty = (object)=>{
    return !isNotEmpty(object);
}